<div class="grid h-full w-full bg-radial-[ellipse_at_top] from-zaeper-primary-500 via-zaeper-secondary-600 to-[#060223] overflow-hidden">
  <div class="text-white self-center justify-self-center h-[66%] w-[66%] flex flex-col gap-8 items-center justify-center relative">
    <div class="h-[50%] max-h-[120px] z-10">
      <img src="assets/images/zaeper_full_vertical.svg" class="h-full w-full brightness-0 invert" alt="zaeper logo"/>
    </div>
    <div class="absolute bottom-[-115%]">
      <ng-lottie [options]="lottieGlobe" class="w-full h-full"/>
    </div>
  </div>
</div>
